import { createContext, useEffect } from "react";
import { useState } from "react";
import { baseUrl, getService, footerSecEndPoint } from "../utils/apiData";
import axios from "axios";

export const mainContext = createContext();

const WebContext = ({ children }) => {
  const [dd, setDd] = useState(false);
  const [footerData, setFooterData] = useState({});

  const [headerService, setHeaderService] = useState([]);
  const [involvedService, setInvolvedService] = useState([]);
  const getServicesApi = async () => {
    try {
      const res = await axios.get(`${baseUrl}/${getService}`);

      if (res?.data?.success) {
        setHeaderService(res?.data?.data?.headerservice);
        setInvolvedService(res?.data?.data?.involvedservice);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getFooterSecApi = async () => {
    try {
      const res = await axios.get(`${baseUrl}/${footerSecEndPoint}`);

      if (res?.data?.success) {
        setFooterData(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getServicesApi();
    getFooterSecApi();
  }, []);

  const data = {
    dd,
    setDd,
    headerService,
    involvedService,
    footerData,
  };
  return <mainContext.Provider value={data}>{children}</mainContext.Provider>;
};

export default WebContext;
